// First, so route schemas build without zod's JIT probe: it calls new Function, which our CSP blocks.
import './config/initializers/zod';

export { default as AppErrorBoundary } from './components/app-error-boundary';
export { LEGACY_IDV_CONTAINER_ID, NAVIGATION_HEADER_PORTAL_ID } from './components/constants';
export type {
  CompletePayload,
  CustomChildAPI,
  ProviderReturn,
  RequirementChangedPayload,
} from './components/footprint-provider';
export {
  configureFootprint,
  default as FootprintProvider,
  useFootprintProvider,
} from './components/footprint-provider';
export { InitShimmer } from './components/init-shimmer';
export { default as Footer } from './components/layout/components/footprint-footer/components/footer-content';
export { default as FullHeightContainer } from './components/layout/components/full-height-container';
export type { HeaderTitleProps } from './components/layout/components/header-title';
export { default as HeaderTitle, HEADER_TITLE_DEFAULT_ID } from './components/layout/components/header-title';
export { LayoutOptionsProvider, useLayoutOptions } from './components/layout/components/layout-options-provider';
export type {
  NavigationHeaderBackButtonProps,
  NavigationHeaderCloseButtonProps,
  NavigationHeaderDynamicContent,
  NavigationHeaderLeftButtonProps,
  NavigationHeaderProps,
  NavigationHeaderRightButtonProps,
  NavigationHeaderStaticContent,
} from './components/layout/components/navigation-header';
export {
  default as NavigationHeader,
  NAVIGATION_HEADER_PORTAL_SELECTOR,
} from './components/layout/components/navigation-header';
export { default as NavigationHeaderContainer } from './components/layout/components/navigation-header/components/navigation-header-container';
export type { SandboxBannerHandler } from './components/layout/components/sandbox-banner';
export { default as SandboxBanner } from './components/layout/components/sandbox-banner';
export { default as SecuredByFootprint } from './components/layout/components/secured-by-footprint';
export { default as StickyBottomBox } from './components/layout/components/sticky-bottom-box';
export { BOTTOM_ACTION_BOX_PORTAL_ID } from './components/layout/components/sticky-bottom-box/constants';
export { BIFROST_CONTAINER_ID, default as Layout } from './components/layout/layout';
export type { Options as LayoutOptions } from './components/layout/types';
export { default as LoadNeuroId } from './components/load-neuro-id';
export { default as SessionExpired } from './components/session-expired';
export { default as enIdv2Json } from './config/locales/en/idv2.json';
export { default as esIdv2Json } from './config/locales/es/idv2.json';
export { CollectCustomData } from './features/collect-custom-data';
export { default as useClipRecorder } from './features/collect-document/components/camera/hooks/use-clip-recorder';
export { default as useUploadVideo } from './features/collect-document/hooks/use-upload-video';
export { default as CollectSelfie } from './features/collect-document/selfie';
export type { HandleFileUploadResult } from './features/collect-document/utils/handle-file-upload';
export { default as handleFileUpload } from './features/collect-document/utils/handle-file-upload';
export { useIdv2 } from './features/idv-to-idv2';
export type {
  AutoAdvance,
  IDV2InitialValues,
  IDV2Store,
  Idv2ProviderProps,
} from './features/idv-to-idv2/idv2-provider';
export {
  callExternalBack,
  getIdv2StoreData,
  Idv2Provider,
  setExternalBack,
  setIdv2StoreData,
} from './features/idv-to-idv2/idv2-provider';
export {
  consumeContinueOnMobile,
  markContinueOnMobile,
  markTransferVisited,
} from './features/idv-to-idv2/store-utils';
export { default as TestIdInput } from './features/sandbox-outcome/components/test-id-input';
export type { Idv2Props } from './idv2';
export { Idv2 } from './idv2';
export { default as getRandomID } from './utils/get-random-id/get-random-id';
export {
  default as Logger,
  formatClientVersion,
  getLogger,
  logClientVersion,
  setTenantLogContext,
  shouldRecordTenantSession,
  trackAction,
} from './utils/logger';
